// pages/email-client-docs.tsx

import React from 'react';
import '../styles/EmailClientDocs.css';
import { PageTitle } from '../components/PageTitle';

export default function EmailClientDocs() {
  return (
    <>
    <PageTitle title="Ephemail Client Documentation" />
    <div className="email-docs-wrapper">
      

      <div className="email-docs-card">
        <h2>📦 Installation</h2>
        <pre><code>dotnet add package EphemailClient</code></pre>
      </div>

      <div className="email-docs-card">
        <h2>🚀 Quick Start</h2>
        <pre><code>{`Email.Epheapi
  .UseEmail("user@ephemail.space")
  .Expect(Templates.Welcome(...))
  .Extract(out var password, EmailRegex.Password)
  .GotoLink("Get Started")
  .Delete();`}</code></pre>
      </div>

      <div className="email-docs-card">
        <h2>📬 Features</h2>
        <ul>
          <li>⏳ Wait for email by subject with timeout</li>
          <li>✅ Validate email content against a template</li>
          <li>🔗 Extract links by anchor text</li>
          <li>🔐 Extract text using regular expressions</li>
          <li>🗑 Delete single or all emails for an address</li>
          <li>🧱 Extendable and independent from Selenium</li>
        </ul>
      </div>

      <div className="email-docs-card">
        <h2>✉️ Template Example</h2>
        <pre><code>{
`public static EmailTemplate WelcomeAsBroker(Broker broker, Admin admin)
{
  return new EmailTemplate(
      // subject:
      $"Welcome to Ephemail!",

      // body:
      $"Dear {broker.FirstName}",
      "We are happy to have you on board!",
      $"Your account was created by {admin.Email}."
  );
}`}</code></pre>

      </div>

      <div className="email-docs-card">
        <h2>📚 Documentation</h2>
        <p>API base URL: <code>https://api.ephemail.space</code></p>
        <p>This client requires .NET 8.0 or newer. Suitable for all C# automation projects.</p>
      </div>
    </div>
    </>
  );
}
